import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=4b864cd0&scoped=true&"
import script from "./complete.vue?vue&type=script&lang=js&"
export * from "./complete.vue?vue&type=script&lang=js&"
import style0 from "./complete.vue?vue&type=style&index=0&id=4b864cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b864cd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
